import Phaser from "phaser";

export default class Button extends Phaser.GameObjects.Sprite {
    constructor(scene, x, y, texture, scale, text, fontSize, callback) {
        super(scene, x, y, texture);
        this.setScale(scale+0.1, scale+0.25);
        this.buttonText = this.scene.add.text(this.x, this.y, text, { fontSize: fontSize.toString() + "px", fontFamily: "TruculentaBold", fill: texture==="GreenButton" ?'000000':'#FFFFFF' , align: 'center' }).setOrigin(0.5, 0.5).setDepth(10001);
        
        //NOTE: setInteractive() must be called in the create() function of the scene
        this.on("pointerdown", () => callback());
        this.on('pointerover', () => {
            this.setScale(1.2*scale, 1.35*scale);
        });
        this.on('pointerout', () => {
            this.setScale(scale+0.1, scale+0.25);
        });
    }

    updateButtonText(text) {
        this.buttonText.setText(text);
    }

    enableButtonTexture() {
        this.clearTint();
        this.buttonText.clearTint();
        this.visible = true;
        this.buttonText.visible = true;
    }

    disableButtonTexture() {
        this.setTint(0x999999);
        this.buttonText.setTint(0x999999);
    }

    setButtonVisibility(isVisible) {
        this.setVisible(isVisible);
        this.buttonText.setVisible(isVisible);
    }
}

// Register a function to the gameobjectfactory, allowing you to use this.add.<objectname>
Phaser.GameObjects.GameObjectFactory.register("button", function (x, y, texture, scale, text, fontSize, callback) {
    const buttonInst = new Button(this.scene, x, y, texture, scale, text, fontSize, callback);

    this.displayList.add(buttonInst);
    this.updateList.add(buttonInst);

    return buttonInst;
})